import { Autocomplete } from "@mui/material";
import { styled } from "@mui/material/styles";
import { StyledTextfield } from "../QuickFilter/styles";

export const StyledAutocomplete = styled(Autocomplete)({
  "& .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon.css-dkoyt8-MuiAutocomplete-root .MuiOutlinedInput-root":
    {
      paddingRight: "50px",
    },
});
export const StyledAutocompleteTextfield = styled(StyledTextfield)({
  // "& .MuiAutocomplete-input" : {
  //   minWidth : "100px !important"
  // },

  "& .MuiAutocomplete-endAdornment": {
    // top:'calc( 50% - 20px)',
    "& button": {
      width: "unset",
      padding: "0",
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
});
